/**
 * Created by mark on 23/01/2018.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {Glyphicon , OverlayTrigger , Tooltip , ControlLabel , Row , Col , FormGroup , FormControl , Table} from 'react-bootstrap';

export default class Correct extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            selected:props.selected
        };

    }

    componentWillReceiveProps(props) {
        this.setState({selected:props.selected})
    }

    render(){
        return <div className="checkbox">
            <label>
                <input  type="checkbox" checked={this.state.selected} value={this.state.selected} />
                <i className="input-helper"></i>
            </label>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/inputs/tickbox.js